import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '../ui/button';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText, confirmStyle, loading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6">
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle size={24} style={{ color: '#EF4444' }} />
            </div>
            <h3 className="text-xl font-bold" style={{ fontFamily: 'Fraunces, serif', color: '#111827' }}>
              {title}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <p className="text-gray-600 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
          {message}
        </p>

        <div className="flex gap-3 justify-end">
          <Button
            onClick={onClose}
            variant="outline"
            className="px-6 py-2"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            className="px-6 py-2"
            style={confirmStyle || { backgroundColor: '#EF4444', color: '#FFFFFF' }}
          >
            {loading ? 'Processing...' : confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
